export default "__VITE_ASSET__ao5zhCR5__"